module.exports = __webpack_public_path__ + "static/media/bonus_level_3.5fd065ff.png";